import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Home from './Home';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import {ConfigProvider, Grid} from "antd";
import Products from "./Products";
import Register from "./Register";
import Login from "./Login";
import Services from "./Services";
import About from "./About";
import Contacts from "./Contacts";


const { useBreakpoint } = Grid;

function App() {
    const screens = useBreakpoint();
    const isMobile = !screens.md;

    return (
          <ConfigProvider
              theme={{
                  "token": {
                      "colorPrimary": "#513f38",
                      "colorInfo": "#513f38",
                      "colorWarning": "#ff6600",
                      "wireframe": false,
                      "textColor": "#513f38 !important",
                      ...(isMobile && {
                          "fontSizeHeading1": 30,
                          "fontSizeHeading2": 26,
                          "fontSizeHeading3": 20,
                          "fontSizeHeading4": 17,
                      }),
                  }
              }}
          >
          <Header />
          <Routes>
              <Route index element={<Home />} />
              <Route path={'/products'} element={<Products />} exact />
              <Route path={'/register'} element={<Register />} exact />
              <Route path={'/login'} element={<Login />} exact />
              <Route path={'/services'} element={<Services />} exact />
              <Route path={'/about'} element={<About />} exact />
              <Route path={'/contacts'} element={<Contacts />} exact />
              {/*<Route path={'/partners'} element={<Partners />} exact />*/}
              {/*<Route path={'/career'} element={<Career />} exact />*/}
              {/*<Route path={'/privacy'} element={<Privacy />} exact />*/}
              {/*<Route path={'/cookies'} element={<Cookies />} exact />*/}
              {/*<Route path={'/terms'} element={<Terms />} exact />*/}
              {/*<Route path={'/help'} element={<Help />} exact />*/}
              {/*<Route path={'/faq'} element={<Faq />} exact />*/}
              {/*<Route path={'/useful'} element={<Useful />} exact />*/}
              {/*<Route path={'/eu'} element={<EU />} exact />*/}
          </Routes>
          <Footer />
          </ConfigProvider>
    );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <BrowserRouter>
          <App />
      </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
